import axios from 'axios'

const baseUrl = process.env.REACT_APP_API_URL;

const updateGettingImageGrid = async (state) => {
  const data = {
    user_id: state?.user_id,
    link_id: state?.link_id,
    id:state?.id,
    coloum_type: state?.coloum_type,
    coloum_name: state?.coloum_name,
    imageFiles:state?.imageFiles,
    optionId: state?.optionId,
    language: state?.language,
  }

  const datass = JSON.stringify(data)
  console.log('datass',state.picture);

  const path = `/api/user/createImageGrid`
  const token = JSON.parse(localStorage.getItem('user')).token
  const bodyFormData = new FormData()
  state?.picture.forEach((image) => {
    bodyFormData.append('picture', image)
  })

  bodyFormData.append('data', datass)
  const url = baseUrl + path
  const response = await axios.post(url, bodyFormData, {
    headers: {
      'Content-Type': 'multipart/form-data',
      Authorization: `'Bearer'${token}`,
    },
  })

  return response.data
}

const gettingImageGrid = async (state) => {
  const data = {
    user_id: state?.user_id,
    link_id: state?.link_id,
    id:state?.id,
    coloum_type: state?.coloum_type,
    coloum_name: state?.coloum_name,
    language: state?.language,
  }
  const datass = JSON.stringify(data)

  const path = `/api/user/createImageGrid`
  const token = JSON.parse(localStorage.getItem('user')).token
  const bodyFormData = new FormData()
  state?.picture.forEach((image) => {
    bodyFormData.append('picture', image)
  })
  bodyFormData.append('data', datass)
  const url = baseUrl + path
  const response = await axios.post(url, bodyFormData, {
    headers: {
      'Content-Type': 'multipart/form-data',
      Authorization: `'Bearer'${token}`,
    },
  })

  return response.data
}

const ImageGridService = {
  gettingImageGrid,
  updateGettingImageGrid,
}

export default ImageGridService
